import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, PieSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_FUNNEL_FORM_DATA,
    EchartsTexturePieChartProps,
    EchartsTexturePieFormData,
    TexturePieChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
import { convertToHexColor, getLegendObject } from '../../utils';
  
export default function transformProps(
    chartProps: EchartsTexturePieChartProps,
): TexturePieChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      tooltipFormat,
      backgroundImage,
      pieImage,
      labelColor,
      labelLineColor,
      labelPosition,
      labelAlignment,
      borderColor,
      showLegend,
      legendOrientation,
      legendMargin
    }: EchartsTexturePieFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_FUNNEL_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel)
      : [groupby].map(getColumnLabel);

    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    const seriesData = data.map(datum => {
      const label = extractGroupbyLabel({
        datum,
        groupby: groupbyLabels,
        coltypeMapping: {},
      });
      return {
        name: label,
        value: datum[metricLabel]
      };
    });

    const bgPatternImg = new Image();
    bgPatternImg.src = backgroundImage;
    const piePatternImg = new Image();
    piePatternImg.src = pieImage;
  
    const series: PieSeriesOption[] = [
      {
        name: metricLabel,
        type: 'pie',
        selectedMode: 'single',
        selectedOffset: 30,
        clockwise: true,
        label: {
          fontSize: 18,
          color: convertToHexColor(labelColor),
          position: labelPosition,
          alignTo: labelAlignment
        },
        labelLine: {
          lineStyle: {
            color: convertToHexColor(labelLineColor)
          }
        },
        itemStyle: {
          opacity: 0.7,
          color: {
            image: piePatternImg,
            repeat: 'repeat'
          },
          borderWidth: 3,
          borderColor: convertToHexColor(borderColor)
        },
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      tooltip: {
        trigger: 'item',
        formatter: tooltipFormat,
      },
      legend: {...getLegendObject(showLegend, legendOrientation,
        legendMargin ? legendMargin.toString() : undefined)},
      backgroundColor: {
        image: bgPatternImg,
        repeat: 'repeat'
      },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  